import React from 'react'

export const Barras = () => {
  return (
    <span id="iconMenu" className="material-symbols-outlined">
      home
    </span>
  )
}
